module.exports = __webpack_public_path__ + "static/media/AgricultureAlimentation_PictoCdlT.cdcef9cd.png";